// extracted by mini-css-extract-plugin
export default {"button":"button--DLG8o+q9vG"};